import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import styled from 'styled-components';

const NavItem = styled.li`
  height: inherit;
`;

const NavLink = styled.a`
  --linkBgColor: ${brand.red.base};
  --linkFgColor: ${brand.white};

  display: inline-flex;
  place-items: center;
  place-content: center;
  height: inherit;
  ${fonts.helvetica['73-bold-extended']}
  font-size: 13px;
  color: var(--linkFgColor) !important;
  background-color: var(--linkBgColor);
  padding: 0px 24px;
  text-transform: uppercase;

  &[aria-current='true'] {
    --linkBgColor: ${brand.white};
    --linkFgColor: ${brand.red.base};
  }

  &:is(span) {
    cursor: default;
  }
`;

const DesktopNavigationLinkStyles = {
  NavItem,
  NavLink,
};

export default DesktopNavigationLinkStyles;
